import React from 'react';
import { DropdownSelector } from 'hyperdb-utils';

const CalendarFilters = (props) => {
  const handleSelect = (attributeName, field) => {
    const filters = { ...props.calendarFilters || {} };
    filters[attributeName] = field.value;
    props.onSelect({ value: filters });
  };
  const firstGroup = props.groups.length > 0 ? props.groups[0].id : null;
  const calendarFilters = props.calendarFilters || {};
  return (
    <fieldset>
      <div className="row">
        {
          ['admin', 'manager'].includes(props.currentUser.group.name)
            ? <div className="col-md-3">
                <DropdownSelector
                  name="group"
                  value={ calendarFilters.group_id || firstGroup }
                  options={ groupsOptions(props.groups) }
                  onChange={ handleSelect.bind(null, 'group_id') }
                />
              </div>
            : null
        }
        {
          ['admin', 'manager'].includes(props.currentUser.group.name)
            ? <div className="col-md-3">
                <DropdownSelector
                  name="owner"
                  value={ calendarFilters.owner_id || 'all' }
                  options={ ownersOptions(props.owners) }
                  onChange={ handleSelect.bind(null, 'owner_id') }
                />
              </div>
            : null
        }
        <div className="col-md-3">
          <DropdownSelector
            name="zone"
            value={ calendarFilters.zone_id || 'all' }
            options={ zonesOptions(props.zones) }
            onChange={ handleSelect.bind(null, 'zone_id') }
          />
        </div>
        <div className="col-md-3">
          <DropdownSelector
            name="area"
            value={ calendarFilters.area_id || 'all' }
            options={ areasOptions(props.areas) }
            onChange={ handleSelect.bind(null, 'area_id') }
          />
        </div>
      </div>
      <br/>
      <div className="row">
        <div className="col-md-3">
          <div className="btn btn-primary btn-sm" onClick={ props.onSubmit.bind(null, props.calendarFilters) } disabled={ props.loading }>Filter</div>
        </div>
      </div>
    </fieldset>
  );
};

function groupsOptions(groups) {
  return [{ name: 'All', value: 'all' }].concat(groups.map(g => ({ name: g.name, value: g.id })));
}
function ownersOptions(owners) {
  return [{ name: 'All', value: 'all' }].concat(owners.map(o => ({ name: o.name, value: o.id })));
}
function zonesOptions(zones) {
  return [{ name: 'All', value: 'all' }].concat(zones.map(z => ({ name: z.name.$i18n.en, value: z.id })));
}
function areasOptions(areas) {
  return [{ name: 'All', value: 'all' }].concat(areas.map(a => ({ name: a.name.$i18n.en, value: a.id })));
}

export default CalendarFilters;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/availabilities/components/CalendarFilters.jsx